import React from 'react';
import cn from 'classnames';
import { App } from '@gin-betting/core';

import './betStatus.scss';

interface Props {
    betStatus: App.BetslipStatus;
}

const BetStatus: React.SFC<Props> = ({ betStatus }) => {
    const isProcessing = betStatus === App.BetslipStatus.PROCESSING;
    const isEditing = betStatus === App.BetslipStatus.EDITING;
    const isSuccess = betStatus === App.BetslipStatus.SUCCESS;

    const isInitial = betStatus === App.BetslipStatus.INITIAL;
    const isError = betStatus === App.BetslipStatus.ERROR;

    return (
        <div
            styleName={cn('container', {
                'is-processing': isProcessing,
                'is-completed': isSuccess,
                'is-editing': isEditing,
                'is-initial': isInitial,
                'is-error': isError,
            })}
            className="__app-BetStatus-container"
        />
    );
};

export default BetStatus;
